<template>
  <div class="border border-gray-700 relative w-full mx-auto border rounded-2xl p-4 bg-gray-800">
    <div class="border border-gray-700 flex items-center bg-gray-800 text-white rounded-2xl px-4 py-2 shadow-md focus-within:ring-2 focus-within:ring-purple-500 transition">
      <MagnifyingGlassIcon class="w-5 h-5 text-gray-400" />
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Search opportunities, categories, or tags..."
        class="bg-transparent focus:outline-none ml-3 text-sm w-full placeholder-gray-400"
      />
      <button v-if="searchQuery" @click="clearSearch" class="ml-2 text-gray-400 hover:text-gray-100 transition">
        <XMarkIcon class="w-5 h-5" />
      </button>
    </div>

    <div
      v-if="searchResults.length && showResults"
      class="absolute z-50 mt-2 w-full bg-gray-900 border border-gray-700 rounded-xl shadow-lg max-h-96 overflow-auto"
    >
      <ul>
        <li
          v-for="(result, index) in searchResults"
          :key="index"
          class="px-4 py-3 hover:bg-gray-700 transition cursor-pointer"
          @click="goToResult(result)"
        >
          <div class="font-medium text-blue-400">{{ result.title }}</div>
          <div class="text-sm text-gray-400 truncate">{{ result.description }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
  import { ref, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/24/outline'
  import { getAllOpportunities } from '@/utils/opportunity'
  import { debounce } from 'lodash'

  const router = useRouter()
  const searchQuery = ref('')
  const searchResults = ref([])
  const showResults = ref(false)

  // Async search logic
  const fetchSearchResults = async (query) => {
    return await getAllOpportunities(6, query)
  }

  // Debounced search
  const debouncedSearch = debounce(async () => {
    if (searchQuery.value.length < 3) {
      searchResults.value = []
      showResults.value = false
      return
    }

    searchResults.value = await fetchSearchResults(searchQuery.value)
    showResults.value = true
  }, 1000)

  // Watch searchQuery and trigger debounce
  watch(searchQuery, () => {
    debouncedSearch()
  })

  const clearSearch = () => {
    searchQuery.value = ''
    searchResults.value = []
    showResults.value = false
  }

  const goToResult = (result) => {
    showResults.value = false
    searchQuery.value = ''
    router.push({
      name: 'OpportunityShow',
      params: {
        id: result.id
      }
    })
  }
</script>